import { render } from "./weekly-updates-card.vue?vue&type=template&id=342f6515"
import script from "./weekly-updates-card.vue?vue&type=script&lang=js"
export * from "./weekly-updates-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__